/* Auto-generated by Arlo Admin — Arch Magnet settings. Do not edit manually. */
window.ArloMagnetConfig = {
  "sizes": {
    "large": {
      "label": "Large Arch 750×950mm",
      "wMm": 750,
      "hMm": 950
    },
    "medium": {
      "label": "Medium Arch 600×760mm",
      "wMm": 600,
      "hMm": 760
    },
    "small": {
      "label": "Small Arch 450×570mm",
      "wMm": 450,
      "hMm": 570
    }
  },
  "designs": {
    "scallop": {
      "label": "Scalloped",
      "type": "vector",
      "recolourable": true
    },
    "rainbow": {
      "label": "Rainbow",
      "type": "vector",
      "recolourable": false
    },
    "rainbow-pastel": {
      "label": "Pastel Rainbow",
      "type": "vector",
      "recolourable": false
    },
    "road": {
      "label": "Road",
      "type": "raster",
      "recolourable": false
    }
  },
  "art": {
    "archMm": {
      "w": 750,
      "h": 950
    },
    "archPath": "M 375.000 0.000 C 167.893 0.000 0.000 169.859 0.000 379.392 L 0.000 950.000 L 750.000 950.000 L 750.000 379.392 C 750.000 169.859 582.107 0.000 375.000 0.000 Z",
    "designs": {
      "scallop": {
        "label": "Scalloped",
        "type": "vector",
        "recolourable": true,
        "reachMm": 100.3,
        "bands": [
          {
            "hex": "",
            "d": "M -0.001 949.974 L -0.001 379.366 C -0.001 169.834 167.892 -0.026 374.999 -0.026 C 582.107 -0.026 749.999 169.834 749.999 379.366 L 749.999 949.974 L 805.288 949.974 C 831.936 932.126 849.482 901.744 849.482 867.261 C 849.482 832.523 831.674 801.941 804.694 784.150 C 831.674 766.356 849.482 735.774 849.482 701.036 C 849.482 666.298 831.674 635.716 804.694 617.921 C 831.674 600.131 849.482 569.548 849.482 534.810 C 849.482 500.041 831.646 469.437 804.624 451.654 C 832.359 433.327 850.280 401.520 849.296 365.847 C 848.138 323.874 821.144 288.691 783.965 275.109 C 810.459 245.618 817.743 201.792 798.965 164.168 C 780.194 126.552 740.792 106.030 701.306 109.459 C 712.813 71.511 700.847 28.716 667.887 2.589 C 634.845 -23.602 590.318 -25.433 555.964 -5.416 C 550.109 -44.814 520.754 -78.462 479.574 -87.818 C 438.447 -97.163 397.476 -79.552 375.152 -46.631 C 352.852 -79.570 311.898 -97.209 270.765 -87.895 C 229.578 -78.568 200.195 -44.938 194.314 -5.543 C 159.975 -25.591 115.440 -23.792 82.378 2.377 L 82.381 2.377 C 49.411 28.475 37.409 71.250 48.874 109.198 C 9.395 105.748 -30.000 126.237 -48.799 163.833 C -67.602 201.435 -60.360 245.250 -33.908 274.764 C -71.080 288.321 -98.093 323.476 -99.285 365.439 C -100.301 401.139 -82.376 432.981 -54.620 451.326 C -81.646 469.109 -99.483 499.712 -99.483 534.486 C -99.483 569.224 -81.678 599.806 -54.694 617.600 C -81.678 635.391 -99.483 665.973 -99.483 700.711 C -99.483 735.450 -81.678 766.031 -54.694 783.826 C -81.678 801.616 -99.483 832.199 -99.483 866.937 C -99.483 901.631 -81.720 932.171 -54.797 949.974 Z",
            "evenOdd": true,
            "reachMm": 100.3
          }
        ]
      },
      "rainbow": {
        "label": "Rainbow",
        "type": "vector",
        "recolourable": false,
        "reachMm": 100,
        "bands": [
          {
            "hex": "#4D8FC3",
            "d": "M 849.810 379.441 L 849.810 950.048 L 824.808 950.048 L 824.808 379.441 C 824.808 318.245 812.941 258.826 789.538 202.837 C 778.277 175.909 764.349 149.948 748.139 125.674 C 732.074 101.618 713.627 78.998 693.314 58.449 C 672.973 37.871 650.592 19.191 626.794 2.925 C 602.731 -13.522 576.989 -27.657 550.280 -39.087 C 523.060 -50.736 494.566 -59.686 465.589 -65.683 C 435.892 -71.832 405.348 -74.947 374.808 -74.947 C 344.268 -74.947 313.725 -71.832 284.028 -65.687 C 255.051 -59.686 226.557 -50.736 199.337 -39.087 C 172.628 -27.657 146.886 -13.522 122.819 2.928 C 99.024 19.191 76.644 37.871 56.303 58.449 C 35.983 79.005 17.536 101.621 1.481 125.667 C -14.732 149.948 -28.663 175.913 -39.921 202.833 C -63.324 258.826 -75.191 318.245 -75.191 379.441 L -75.191 950.048 L -100.193 950.048 L -100.193 379.441 C -100.193 314.911 -87.673 252.251 -62.985 193.192 C -51.111 164.793 -36.418 137.404 -19.311 111.785 C -2.371 86.417 17.088 62.558 38.523 40.873 C 59.975 19.170 83.590 -0.543 108.715 -17.713 C 134.126 -35.083 161.307 -50.006 189.501 -62.071 C 218.260 -74.379 248.355 -83.830 278.959 -90.166 C 310.321 -96.657 342.568 -99.949 374.808 -99.949 C 407.049 -99.949 439.296 -96.657 470.655 -90.166 C 501.258 -83.830 531.357 -74.379 560.116 -62.071 C 588.310 -50.006 615.491 -35.083 640.902 -17.713 C 666.027 -0.543 689.641 19.170 711.094 40.873 C 732.529 62.558 751.984 86.417 768.928 111.789 C 786.034 137.404 800.728 164.793 812.602 193.192 C 837.290 252.251 849.810 314.911 849.810 379.441",
            "evenOdd": false,
            "reachMm": 100.2
          },
          {
            "hex": "#9CDCC4",
            "d": "M 824.808 379.441 L 824.808 950.048 L 799.860 950.048 L 799.860 379.441 C 799.860 321.568 788.641 265.384 766.519 212.461 C 755.875 187.011 742.713 162.472 727.389 139.527 C 712.205 116.791 694.771 95.413 675.569 75.989 C 656.350 56.544 635.201 38.891 612.711 23.524 C 589.992 7.991 565.682 -5.358 540.462 -16.150 C 514.773 -27.146 487.877 -35.591 460.530 -41.254 C 432.495 -47.057 403.655 -49.999 374.808 -49.999 C 345.962 -49.999 317.122 -47.057 289.087 -41.254 C 261.740 -35.591 234.847 -27.146 209.151 -16.150 C 183.934 -5.358 159.625 7.991 136.899 23.527 C 114.416 38.891 93.271 56.544 74.048 75.989 C 54.839 95.420 37.405 116.794 22.228 139.524 C 6.904 162.472 -6.259 187.011 -16.898 212.457 C -39.025 265.384 -50.243 321.568 -50.243 379.441 L -50.243 950.048 L -75.191 950.048 L -75.191 379.441 C -75.191 318.245 -63.324 258.826 -39.921 202.833 C -28.664 175.913 -14.732 149.948 1.481 125.667 C 17.536 101.621 35.983 79.005 56.303 58.449 C 76.644 37.871 99.024 19.191 122.819 2.928 C 146.886 -13.522 172.628 -27.657 199.337 -39.087 C 226.557 -50.736 255.051 -59.686 284.028 -65.687 C 313.725 -71.832 344.268 -74.947 374.808 -74.947 C 405.348 -74.947 435.892 -71.832 465.589 -65.683 C 494.566 -59.686 523.060 -50.736 550.280 -39.087 C 576.989 -27.657 602.731 -13.522 626.794 2.925 C 650.592 19.191 672.973 37.871 693.314 58.449 C 713.627 78.998 732.074 101.618 748.139 125.674 C 764.349 149.948 778.277 175.909 789.538 202.837 C 812.941 258.826 824.808 318.245 824.808 379.441",
            "evenOdd": false,
            "reachMm": 75.2
          },
          {
            "hex": "#F9B16B",
            "d": "M 799.860 379.441 L 799.860 950.048 L 774.809 950.048 L 774.809 379.441 C 774.809 324.895 764.243 271.967 743.405 222.123 C 733.386 198.163 720.989 175.052 706.554 153.437 C 692.259 132.027 675.837 111.894 657.754 93.596 C 639.663 75.294 619.756 58.678 598.582 44.203 C 577.194 29.584 554.323 17.029 530.609 6.879 C 481.252 -14.241 428.833 -24.952 374.808 -24.952 C 320.784 -24.952 268.365 -14.241 219.004 6.879 C 195.290 17.029 172.423 29.584 151.034 44.203 C 129.861 58.678 109.953 75.294 91.863 93.596 C 73.776 111.894 57.358 132.027 43.060 153.437 C 28.628 175.052 16.227 198.163 6.212 222.123 C -14.626 271.967 -25.192 324.895 -25.192 379.441 L -25.192 950.048 L -50.243 950.048 L -50.243 379.441 C -50.243 321.568 -39.025 265.384 -16.898 212.457 C -6.259 187.011 6.904 162.472 22.228 139.524 C 37.405 116.794 54.839 95.420 74.048 75.989 C 93.271 56.544 114.416 38.891 136.899 23.527 C 159.625 7.991 183.934 -5.358 209.151 -16.150 C 234.847 -27.146 261.740 -35.591 289.087 -41.254 C 317.122 -47.057 345.962 -49.999 374.808 -49.999 C 403.655 -49.999 432.495 -47.057 460.530 -41.254 C 487.877 -35.591 514.773 -27.146 540.462 -16.150 C 565.682 -5.358 589.992 7.991 612.711 23.524 C 635.201 38.891 656.350 56.544 675.569 75.989 C 694.771 95.413 712.205 116.791 727.389 139.527 C 742.713 162.472 755.875 187.011 766.519 212.461 C 788.641 265.384 799.860 321.568 799.860 379.441",
            "evenOdd": false,
            "reachMm": 50.2
          },
          {
            "hex": "#D5603A",
            "d": "M 774.809 379.441 L 774.809 950.048 L 749.808 950.048 L 749.808 379.441 C 749.808 169.909 581.914 0.050 374.808 0.050 C 167.700 0.050 -0.191 169.909 -0.191 379.441 L -0.191 950.048 L -25.192 950.048 L -25.192 379.441 C -25.192 324.895 -14.626 271.967 6.212 222.123 C 16.227 198.163 28.628 175.052 43.060 153.437 C 57.358 132.027 73.776 111.894 91.863 93.596 C 109.953 75.294 129.861 58.678 151.034 44.203 C 172.423 29.584 195.290 17.029 219.004 6.879 C 268.365 -14.241 320.784 -24.952 374.808 -24.952 C 428.833 -24.952 481.252 -14.241 530.609 6.879 C 554.323 17.029 577.194 29.584 598.582 44.203 C 619.756 58.678 639.663 75.294 657.754 93.596 C 675.837 111.894 692.259 132.027 706.554 153.437 C 720.989 175.052 733.386 198.163 743.405 222.123 C 764.243 271.967 774.809 324.895 774.809 379.441",
            "evenOdd": false,
            "reachMm": 25.2
          }
        ]
      },
      "rainbow-pastel": {
        "label": "Pastel Rainbow",
        "type": "vector",
        "recolourable": false,
        "reachMm": 100,
        "bands": [
          {
            "hex": "#C998D2",
            "d": "M 849.995 379.366 L 849.995 949.974 L 816.714 949.974 L 816.714 379.366 C 816.714 319.274 805.062 260.928 782.085 205.955 C 771.029 179.521 757.355 154.030 741.438 130.196 C 725.662 106.574 707.554 84.370 687.611 64.195 C 667.641 43.991 645.670 25.654 622.305 9.687 C 598.690 -6.456 573.424 -20.331 547.206 -31.549 C 520.493 -42.983 492.532 -51.763 464.095 -57.651 C 434.948 -63.684 404.973 -66.742 374.994 -66.742 C 345.015 -66.742 315.036 -63.684 285.889 -57.651 C 257.452 -51.763 229.491 -42.983 202.778 -31.549 C 176.567 -20.331 151.297 -6.460 127.675 9.687 C 104.314 25.657 82.343 43.995 62.376 64.195 C 42.427 84.381 24.315 106.585 8.549 130.192 C -7.368 154.033 -21.042 179.521 -32.094 205.951 C -55.074 260.928 -66.726 319.271 -66.726 379.366 L -66.726 949.974 L -100.007 949.974 L -100.007 379.366 C -100.007 314.836 -87.487 252.176 -62.800 193.117 C -50.925 164.719 -36.232 137.329 -19.126 111.710 C -2.186 86.342 17.274 62.484 38.708 40.799 C 60.161 19.096 83.776 -0.618 108.897 -17.787 C 134.311 -35.158 161.493 -50.081 189.687 -62.146 C 218.442 -74.454 248.541 -83.905 279.144 -90.241 C 310.506 -96.732 342.753 -100.023 374.994 -100.023 C 407.234 -100.023 439.482 -96.732 470.840 -90.241 C 501.443 -83.905 531.542 -74.454 560.301 -62.146 C 588.495 -50.081 615.676 -35.158 641.087 -17.787 C 666.212 -0.618 689.827 19.096 711.279 40.799 C 732.714 62.484 752.170 86.342 769.114 111.710 C 786.220 137.329 800.913 164.719 812.787 193.117 C 837.475 252.176 849.995 314.836 849.995 379.366",
            "evenOdd": false,
            "reachMm": 100
          },
          {
            "hex": "#F8B5DD",
            "d": "M 816.714 379.366 L 816.714 949.974 L 783.274 949.974 L 783.274 379.366 C 783.274 323.719 772.493 269.716 751.228 218.853 C 741.008 194.405 728.354 170.822 713.625 148.763 C 699.038 126.915 682.281 106.373 663.827 87.700 C 645.366 69.024 625.050 52.063 603.438 37.295 C 581.605 22.373 558.262 9.553 534.054 -0.808 C 483.660 -22.370 430.143 -33.306 374.994 -33.306 C 319.840 -33.306 266.328 -22.370 215.933 -0.808 C 191.726 9.553 168.379 22.373 146.549 37.295 C 124.938 52.063 104.621 69.024 86.160 87.700 C 67.703 106.373 50.950 126.915 36.359 148.763 C 21.630 170.822 8.980 194.405 -1.244 218.853 C -22.506 269.716 -33.287 323.719 -33.287 379.366 L -33.287 949.974 L -66.726 949.974 L -66.726 379.366 C -66.726 319.271 -55.074 260.928 -32.094 205.951 C -21.042 179.521 -7.368 154.033 8.549 130.192 C 24.315 106.585 42.427 84.381 62.376 64.195 C 82.343 43.995 104.314 25.657 127.675 9.687 C 151.297 -6.460 176.567 -20.331 202.778 -31.549 C 229.491 -42.983 257.452 -51.763 285.889 -57.651 C 315.036 -63.684 345.015 -66.742 374.994 -66.742 C 404.973 -66.742 434.948 -63.684 464.095 -57.651 C 492.532 -51.763 520.493 -42.983 547.206 -31.549 C 573.424 -20.331 598.690 -6.456 622.305 9.687 C 645.670 25.654 667.641 43.991 687.611 64.195 C 707.554 84.370 725.662 106.574 741.438 130.196 C 757.355 154.030 771.029 179.521 782.085 205.955 C 805.062 260.928 816.714 319.274 816.714 379.366",
            "evenOdd": false,
            "reachMm": 66.7
          },
          {
            "hex": "#FBE767",
            "d": "M 783.274 379.366 L 783.274 949.974 L 749.993 949.974 L 749.993 379.366 C 749.993 169.834 582.099 -0.025 374.994 -0.025 C 167.885 -0.025 -0.006 169.834 -0.006 379.366 L -0.006 949.974 L -33.287 949.974 L -33.287 379.366 C -33.287 323.719 -22.506 269.716 -1.244 218.853 C 8.980 194.405 21.630 170.822 36.359 148.763 C 50.950 126.915 67.703 106.373 86.160 87.700 C 104.621 69.024 124.938 52.063 146.549 37.295 C 168.379 22.373 191.726 9.553 215.933 -0.808 C 266.328 -22.370 319.840 -33.306 374.994 -33.306 C 430.143 -33.306 483.660 -22.370 534.054 -0.808 C 558.262 9.553 581.605 22.373 603.438 37.295 C 625.050 52.063 645.366 69.024 663.827 87.700 C 682.281 106.373 699.038 126.915 713.625 148.763 C 728.354 170.822 741.008 194.405 751.228 218.853 C 772.493 269.716 783.274 323.719 783.274 379.366",
            "evenOdd": false,
            "reachMm": 33.3
          }
        ]
      },
      "road": {
        "label": "Road",
        "type": "raster",
        "recolourable": false,
        "reachMm": 99.6,
        "src": "artwork/magnet-road.png",
        "boxMm": {
          "x": -99.55,
          "y": -99.58,
          "w": 950.38,
          "h": 1050.13
        }
      }
    }
  },
  "arch": {
    "sizes": [
      {
        "key": "large",
        "label": "Large Arch 750×950mm",
        "wMm": 750,
        "hMm": 950,
        "enabled": true
      },
      {
        "key": "medium",
        "label": "Medium Arch 600×760mm",
        "wMm": 600,
        "hMm": 760,
        "enabled": false
      },
      {
        "key": "small",
        "label": "Small Arch 450×570mm",
        "wMm": 450,
        "hMm": 570,
        "enabled": false
      }
    ],
    "artwork": "",
    "artworkName": ""
  },
  "archColours": [
    {
      "name": "Vanilla",
      "hex": "#ebe6c7",
      "variantId": "45372815966390"
    },
    {
      "name": "Sage",
      "hex": "#abbfb3",
      "variantId": "45372815900854"
    },
    {
      "name": "Pink Clay",
      "hex": "#e4b5a4",
      "variantId": "45372815933622"
    },
    {
      "name": "Sky",
      "hex": "#d6e7f5",
      "variantId": "45372815999158"
    }
  ],
  "borders": [
    {
      "id": "border-1787280504401",
      "design": "rainbow",
      "label": "Retro Rainbow",
      "colour": null,
      "enabled": true,
      "addonVariantId": "45372704587958",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280503500",
      "design": "scallop",
      "label": "Lemon",
      "colour": {
        "name": "Lemon",
        "hex": "#e9de95"
      },
      "enabled": true,
      "addonVariantId": "45372704522422",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280501282",
      "design": "scallop",
      "label": "Dusty Pink",
      "colour": {
        "name": "Dusty Pink",
        "hex": "#d19997"
      },
      "enabled": true,
      "addonVariantId": "45372704424118",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280497410",
      "design": "scallop",
      "label": "Blue",
      "colour": {
        "name": "Blue",
        "hex": "#5e7b98"
      },
      "enabled": true,
      "addonVariantId": "45372704456886",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280502566",
      "design": "scallop",
      "label": "Green",
      "colour": {
        "name": "Green",
        "hex": "#859f8f"
      },
      "enabled": true,
      "addonVariantId": "45372704489654",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280569242",
      "design": "scallop",
      "label": "Lavender",
      "colour": {
        "name": "Lavender",
        "hex": "#cab6cd"
      },
      "enabled": true,
      "addonVariantId": "45372704555190",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280505319",
      "design": "rainbow-pastel",
      "label": "Pastel Rainbow",
      "colour": null,
      "enabled": true,
      "addonVariantId": "45372704620726",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    },
    {
      "id": "border-1787280506637",
      "design": "road",
      "label": "Road",
      "colour": null,
      "enabled": true,
      "addonVariantId": "45372704653494",
      "includedVariantId": "",
      "addonPrice": 50,
      "addonCompareAt": 0
    }
  ],
  "packs": [],
  "addons": [
    {
      "id": "border",
      "kind": "border",
      "enabled": true,
      "title": "Add a decal border",
      "description": "Scalloped, road or rainbow — frames the arch on the wall.",
      "variantId": "45372702392502",
      "fullPrice": 50,
      "discountedPrice": 40,
      "discountAmount": 10,
      "productId": "8861487562934",
      "compareAtPrice": 0
    },
    {
      "id": "crayons",
      "kind": "crayons",
      "enabled": true,
      "title": "Add a set of crayons",
      "description": "Wipe-clean crayons made for drawing on the magnet surface.",
      "variantId": "45218028028086",
      "fullPrice": 13.5,
      "discountedPrice": 13.5,
      "discountAmount": 0,
      "noDiscount": true,
      "compareAtPrice": 15
    }
  ],
  "linkedProducts": {
    "border": "",
    "crayons": ""
  },
  "mockups": {},
  "preview": {
    "wallHex": "#ffffff",
    "roomImage": "/uploads/magnets/1787288935343-LAYER1-ROOM-2.png",
    "roomImageName": "LAYER1 ROOM 2.png",
    "roomForeground": "/uploads/magnets/1787289915768-LAYER2-ROOM-2.png",
    "roomForegroundName": "LAYER2 ROOM 2.png",
    "arch": {
      "centreXPct": 47.5,
      "bottomYPct": 75.5,
      "heightPct": 59
    },
    "borderScalePct": 112,
    "roomAsset": "arlo-magnet-room.png",
    "roomForegroundAsset": "arlo-magnet-room-fg.png",
    "roomAssetV": "582540225",
    "roomForegroundAssetV": "583520642"
  },
  "uploadcarePublicKey": "58028aeb7a09a9604d9a",
  "saleSuppressCollections": [],
  "saleModeAll": false,
  "saleExcludeCollections": [],
  "saleColour": "#fab699",
  "saleTextColour": "#2b2b2b",
  "addonProductHandles": [
    "magarch-border",
    "washable-crayon-set"
  ]
};
